import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, CardItem, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';
import { ActiveDisplay } from '../ActiveDisplay';

export interface IDisplayAdditionalStatsCardProps {
    readonly display: ActiveDisplay;
    readonly loading?: boolean;
    readonly statusPoll?: Mri.DisplayStatuses.DisplayStatusPoll;
}

@autoinject
@observer
export class DisplayAdditionalStatsCard extends React.Component<IDisplayAdditionalStatsCardProps> {
    public render() {
        const { statusPoll } = this.props;

        return (
            <StatusCard title="Stats" loading={this.props.loading}>
                {statusPoll?.power && <CardItem label="Total Wattage" value={`${this.totalWattage} Watts`} />}

                {this.findFanBank('Closed Loop') && (
                    <CardItem label="CL Fan Utilization" value={this.findFanBank('Closed Loop')!.pwm + '%'} />
                )}

                {this.findFanBank('Open Loop') && (
                    <CardItem label="OL Fan Utilization" value={this.findFanBank('Open Loop')!.pwm + '%'} />
                )}

                {this.findSensor('Door Status') && (
                    <CardItem
                        label="Door Status"
                        value={this.findSensor('Door Status')!.intValue! > 0 ? 'Open' : 'Closed'}
                    />
                )}

                {statusPoll?.sensors
                    ?.filter(s => s.name?.toLowerCase().includes('door'))
                    .map((s, idx) => (
                        <CardItem key={idx} label={s.name!} value={s.boolValue ? 'OPEN' : 'Closed'} />
                    ))}

                {statusPoll?.sensors
                    ?.filter(s => s.name?.toLowerCase().includes('suppressor'))
                    .map((s, idx) => (
                        <CardItem key={idx} label={s.name!} value={s.boolValue ? 'FAILED' : 'Ok'} />
                    ))}
            </StatusCard>
        );
    }

    @bind
    private findSensor(name: string) {
        if (this.props.statusPoll?.sensors) {
            const measurement = this.props.statusPoll.sensors.find(s => s.name == name);
            return measurement;
        }
    }

    @bind
    private findFanBank(name: string) {
        if (this.props.statusPoll?.fanBanks) {
            const fan = this.props.statusPoll.fanBanks.find(s => s.name == name);
            return fan;
        }
    }

    @computed
    private get totalWattage() {
        if (!this.props.statusPoll?.power) return;

        const power = this.props.statusPoll.power;

        if (power.totalWattage) {
            return power.totalWattage.toFixed(2);
        } else if (power.powerSupplies?.length && power.powerSupplies.every(p => !!p.wattage)) {
            return power.powerSupplies
                .reduce((wattage, p) => {
                    return wattage + p.wattage;
                }, 0)
                .toFixed(2);
        } else if (power.powerSupplies?.length && power.powerSupplies.every(p => !!p.voltage && !!p.current)) {
            return power.powerSupplies
                .reduce((wattage, p) => {
                    return wattage + p.current * p.voltage;
                }, 0)
                .toFixed(2);
        } else if (power.avgCurrent && power.avgVoltage) {
            return (power.avgCurrent * power.avgVoltage).toFixed(2);
        }
    }
}
